module.exports = __webpack_public_path__ + "img/sort-z-to-a-green.4ddbc705.svg";